<template>
  <div class="toolPopupCollection">
    <!-- 重启 -->
    <van-dialog v-model="allShow" :showConfirmButton="false">
      <div class="TitleBox">
        <div class="deleteTitle">{{ operate }}云手机</div>
        <img src="@/assets/icons/x.png" alt="" @click="allShow = false" />
      </div>
      <div class="hintText">是否确定重启云手机？重启期间无法进行其他操作！</div>
      <div class="deleteOperate">
        <button class="button deleteCancel" @click="allShow = false">
          取消
        </button>
        <button class="button deleteAffirm" @click="allAffirm">确认</button>
      </div>
    </van-dialog>
    <!-- 恢复出厂 -->
    <van-dialog v-model="factoryShow" :showConfirmButton="false">
      <div class="TitleBox">
        <div class="deleteTitle">{{ operate }}设置</div>
        <img src="@/assets/icons/x.png" alt="" @click="factoryShow = false" />
      </div>
      <div class="hintText">
        恢复出厂设置将清除手机上的所有数据，建议谨慎操作！
      </div>
      <div class="deleteOperate">
        <button class="button deleteCancel" @click="factoryShow = false">
          取消
        </button>
        <button v-show="count != 0" class="button deleteAffirm gram">
          恢复出厂({{ count }}s)
        </button>
        <button
          v-show="count == 0"
          class="button deleteAffirm"
          @click="factoryAffirm"
        >
          恢复出厂
        </button>
      </div>
    </van-dialog>
    <!-- 重命名 -->
    <van-dialog v-model="nameShow" :showConfirmButton="false">
      <div class="TitleBox">
        <div class="deleteTitle">{{ operate }}</div>
        <img src="@/assets/icons/x.png" alt="" @click="nameShow = false" />
      </div>
      <div>
        <van-field
          maxlength="12"
          v-model="nameValue"
          placeholder="请输入云手机名称"
          class="hintText name"
          size="small"
          @focus="obtain"
          @blur="focus = false"
        />
        <div :class="['wire', focus ? 'purple' : '']"></div>
      </div>
      <div class="deleteOperate">
        <button class="button deleteCancel" @click="nameShow = false">
          取消
        </button>
        <button class="button deleteAffirm" @click="nameAffirm">确认</button>
      </div>
    </van-dialog>
    <!-- 一键新机 -->
    <van-dialog v-model="machineShow" :showConfirmButton="false">
      <div class="TitleBox">
        <div class="deleteTitle">{{ operate }}</div>
        <img src="@/assets/icons/x.png" alt="" @click="machineShow = false" />
      </div>
      <div class="hintText">
        是否确定随机更换云手机品牌型号？ 期间云手机需要重启无法操作！
      </div>
      <div class="deleteOperate">
        <button
          type="button"
          class="button machineAffirm"
          @click="equipmentSelect"
        >
          选择品牌
        </button>
        <button
          type="button"
          class="button machineAffirm"
          @click="nweMachineAffirm(1)"
        >
          平版模式
        </button>
        <button
          type="button"
          class="button machineAffirm"
          @click="nweMachineAffirm1"
        >
          随机更换
        </button>
      </div>
    </van-dialog>
    <!-- 重启 -->
    <van-dialog v-model="replaceEquipmentShow" :showConfirmButton="false">
      <div class="TitleBox">
        <div class="deleteTitle">{{ operate }}</div>
        <img
          src="@/assets/icons/x.png"
          alt=""
          @click="replaceEquipmentShow = false"
        />
      </div>
      <div class="hintText">
        将为您随机更换一台云手机，云手机内数据将自动清空，是否确定更换？(注：更换操作不可逆，确定之后数据将被清空无法找回)
      </div>
      <div class="deleteOperate">
        <button
          class="button deleteCancel"
          @click="replaceEquipmentShow = false"
        >
          取消
        </button>
        <button class="button deleteAffirm" @click="replaceEquipmentShowAffirm">
          确认
        </button>
      </div>
    </van-dialog>
    <van-popup
      v-model="pickerShow"
      round
      position="bottom"
      @close="monitorClose"
    >
      <div class="picker_toolbar">
        <button type="button" class="picker_cancel" @click="pickerShow = false">
          取消
        </button>
        <div class="picker_title">选择品牌型号</div>
        <button type="button" class="picker_confirm" @click="onFinish">
          确定
        </button>
      </div>
      <form action="/" v-show="searchShow">
        <van-search
          v-model="brandValue"
          shape="round"
          background="#fff"
          placeholder="搜索品牌关键词"
          @search="onBrandSearch"
        />
      </form>
      <form action="/" v-show="!searchShow">
        <van-search
          v-model="modelValue"
          shape="round"
          background="#fff"
          placeholder="搜索型号关键词"
          @search="onModelSearch"
        />
      </form>
      <van-cascader
        v-model="cascaderValue"
        :options="columns"
        @close="pickerShow = false"
        @change="onConfirm"
        active-color="#886DF3"
        :show-header="false"
        :placeholder="unselectedName"
      />
    </van-popup>
  </div>
</template>
        
  <script>
import { Toast } from "vant";
import { groupList } from "@/api/index";
import {
  commandreboot,
  commandreset,
  commandnewPad,
  phoneModelList,
  rename,
  instanceupdate,
  instancechange,
} from "@/api/instance/index";
export default {
  name: "ToolPopupCollection",
  components: {},
  props: {
    result: {
      default: null,
      type: Array,
    },
  },
  data() {
    return {
      allShow: false,
      factoryShow: false,
      nameShow: false,
      machineShow: false,
      count: "",
      timer: null,
      instanceCode: [],
      ids: [],
      focus: false,
      nameValue: "",
      pickerShow: false,
      columns: [],
      modelList: [],
      cascaderValue: "",
      selectBrand: {},
      brandValue: "",
      modelValue: "",
      unselectedName: "",
      selectValue: [],
      searchShow: true,
      observer: null,
      operate: "",
      replaceEquipmentShow: false,
    };
  },
  mounted() {
    this.getPhoneModelList("", "");
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    // 判断当前tab页
    SearchCurrent(em) {
      let _index = -1;
      this.selectValue.forEach((item, index) => {
        if (item.text == em) {
          _index = index;
        }
      });

      if (this.unselectedName == "请选择品牌" || _index == 0) {
        this.searchShow = true;
      } else {
        this.searchShow = false;
      }
    },
    // 品牌搜索
    onBrandSearch(val) {
      this.selectBrand = {};
      this.cascaderValue = "";
      this.modelValue = "";
      this.getPhoneModelList(val, "");
    },
    // 型号搜索
    onModelSearch(val) {
      this.selectBrand = {};
      if (this.selectValue.length > 0) {
        this.cascaderValue = this.selectValue[0].text;
      }
      this.getPhoneModelList(this.brandValue, val);
    },
    // 查询品牌型号
    getPhoneModelList(brandValue, modelValue) {
      this.columns = [];
      phoneModelList().then((res) => {
        if (res.code == 200) {
          this.modelList = res.data.modelList;
          res.data.brandList.forEach((item, index) => {
            this.columns.push({
              text: item.brand,
              value: item.brand,
              children: [],
            });
            res.data.modelList.forEach((list) => {
              if (item.brand == list.brand) {
                this.columns[index].children.push({
                  text: list.label,
                  value: list.model,
                });
              }
            });
          });
          if (brandValue != "") {
            this.columns = this.columns.filter((item) => {
              return (
                item.text.toLowerCase().indexOf(brandValue.toLowerCase()) != -1
              );
            });
          }
          if (modelValue != "") {
            this.columns.forEach((item, index) => {
              this.columns[index].children = item.children.filter((item) => {
                return (
                  item.text.toLowerCase().indexOf(modelValue.toLowerCase()) !=
                  -1
                );
              });
            });
          }
        }
      });
    },
    // 选择品牌一键新机
    equipmentSelect() {
      this.getPhoneModelList("", "");
      this.machineShow = false;
      this.pickerShow = true;
      let that = this;
      this.$nextTick(function () {
        // 选择目标节点
        const targetNode = document.querySelector(".van-tabs__line");
        // 创建一个观察者对象
        that.observer = new MutationObserver(function (
          mutationsList,
          observer
        ) {
          // 若有变动，则会执行到这里
          for (let mutation of mutationsList) {
            if (
              mutation.type === "childList" ||
              mutation.type === "attributes"
            ) {
              // 这里可以执行你需要的操作
              that.unselectedName =
                document.querySelectorAll(".van-cascader__tab").length <= 1
                  ? "请选择品牌"
                  : "请选择型号";
              const tab_active = document.querySelector(".van-tab--active");
              that.SearchCurrent(tab_active.firstChild.innerHTML);
            }
          }
        });
        // 使用配置文件调用observe方法
        const config = { attributes: true, childList: true, subtree: true };

        // 开始观察已配置观察的目标节点
        that.observer.observe(targetNode, config);
      });
    },
    monitorClose() {
      this.cascaderValue = "";
      this.brandValue = "";
      this.modelValue = "";
    },
    onFinish() {
      if (JSON.stringify(this.selectBrand) === "{}") {
        Toast("品牌和型号为必选");
      } else {
        commandnewPad(this.selectBrand).then((res) => {
          if (res.code == 200) {
            this.pickerShow = false;
            Toast("云手机将在一分钟内重启，期间无法操作！");
            this.$bus.$emit("instanceOperate", "");
          }
        });
      }
    },
    onConfirm({ value, selectedOptions, tabIndex }) {
      this.selectValue = selectedOptions;
      this.selectBrand = {};
      if (selectedOptions.length >= 2) {
        let ids = this.result.map(function (item) {
          return item.id;
        });
        this.selectBrand = {
          ids,
          brand: selectedOptions[0].value,
          model: selectedOptions[1].value,
          manufacturer: selectedOptions[0].value,
        };
      }
    },

    movement(code) {
      this.operate = code;
      this.instanceCode = this.result.map(function (item) {
        return item.instanceCode;
      });
      this.ids = this.result.map(function (item) {
        return item.id;
      });
      if (this.result.length > 0) {
        if (this.operate == "重启") {
          this.allShow = true;
        }
        if (this.operate == "恢复出厂") {
          this.countDown();
          this.factoryShow = true;
        }
        if (this.operate == "更换机型") {
          this.machineShow = true;
        }
        if (this.operate == "重命名") {
          this.nameShow = true;
        }
        if (this.operate == "更换设备") {
          this.replaceEquipmentShow = true;
        }
      } else {
        Toast("请选择设备");
      }
    },
    // 重启确认
    allAffirm() {
      if (this.operate == "重启") {
        let data = {
          instanceCodes: this.instanceCode,
        };
        commandreboot(data).then((res) => {
          if (res.code == 200) {
            Toast("云手机将在一分钟内重启，期间无法操作！");
            this.allShow = false;
            this.$bus.$emit("instanceOperate", "");
          }
        });
      }
    },
    // 确认更换设备
    replaceEquipmentShowAffirm() {
      console.log(this.ids[0]);
      instancechange(this.ids[0]).then((res) => {
        if (res.code == 200) {
          Toast("设备更换成功！");
          this.replaceEquipmentShow = false;
          this.$bus.$emit("instanceOperate", "");
        }
      });
    },
    // 恢复出厂确认
    factoryAffirm() {
      let data = {
        instanceCodes: this.instanceCode,
      };
      commandreset(data).then((res) => {
        if (res.code == 200) {
          Toast("云手机将在三分钟内恢复出厂设置，期间无法操作！");
          this.factoryShow = false;
          this.$bus.$emit("instanceOperate", "");
        } else {
          Toast(res.msg);
        }
      });
    },
    // 修改名称
    nameAffirm() {
      let ids = this.result.map(function (item) {
        return item.id;
      });
      if (ids.length > 1) {
        let data = {
          instanceIds: ids,
          newName: this.nameValue,
        };
        rename(data).then((res) => {
          if (res.code == 200) {
            this.nameShow = false;
            this.$bus.$emit("instanceOperate", "");
            Toast("修改成功！");
          }
        });
      } else {
        let data = {
          id: ids[0],
          instanceName: this.nameValue,
        };
        instanceupdate(data).then((res) => {
          if (res.code == 200) {
            this.nameShow = false;
            //全局事件总线 发布通知
            this.$bus.$emit("instanceOperate", "");
            Toast("设备名称修改成功！");
          }
        });
      }
    },
    nweMachineAffirm(e) {
      let ids = this.result.map(function (item) {
        return item.id;
      });
      let data = {
        ids: ids,
        flag: e,
      };
      commandnewPad(data).then((res) => {
        if (res.code == 200) {
          Toast("云手机将在一分钟内重启，期间无法操作！");
          this.machineShow = false;
          this.$bus.$emit("instanceOperate", "");
        } else {
          Toast(res.msg);
        }
      });
    },
    nweMachineAffirm1() {
      let ids = this.result.map(function (item) {
        return item.id;
      });
      let data = {
        ids: ids,
      };
      commandnewPad(data).then((res) => {
        if (res.code == 200) {
          Toast("云手机将在一分钟内重启，期间无法操作！");
          this.machineShow = false;
          this.$bus.$emit("instanceOperate", "");
        } else {
          Toast(res.msg);
        }
      });
    },

    // 恢复出厂倒计时
    countDown() {
      const TIME_COUNT = 5;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            //限制倒计时区间
            this.count--;
          } else {
            clearInterval(this.timer); //删除定时器
            this.timer = null;
            //跳转的页面写在此处
            // this.$router.push('/vaccineProtectionTk')
          }
        }, 1000);
      }
    },
    obtain() {
      this.focus = true;
    },
  },
};
</script>
        
  <style lang="less" scoped>
.van-cell {
  padding: 12px 0;
}
.button {
  border: none;
  background: none;
}
.TitleBox {
  position: relative;
  img {
    width: 16px;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translate(-50%, -50%);
  }
}
.deleteTitle {
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin-top: 16px;
}
.hintText {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  margin-top: 26px;
  padding: 0 24px;
}
.name {
  padding: 12px 24px;
}
.deleteOperate {
  margin: 38px auto 20px auto;
  .deleteCancel {
    width: 116px;
    height: 40px;
    background: #edeff3;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #9b9b9b;
    margin-right: 16px;
    line-height: 40px;
  }
  .deleteAffirm {
    width: 116px;
    height: 40px;
    background: #886df3;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
  }
  .machineAffirm {
    width: 25%;
    height: 34px;
    background: #886df3;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    line-height: 30px;
    margin-left: 12px;
  }
  .gram {
    background: #aaacb5;
  }
}
.wire {
  height: 1px;
  width: 85%;
  background-color: #f0ebeb;
  margin: 0 auto;
}
.purple {
  background-color: #886df3;
}
.van-cell::after {
  display: none;
}
/deep/ .van-field__control {
  height: 40px;
}
/deep/.van-tabs__wrap {
  display: block !important;
  padding-bottom: 18px;
}
/deep/.van-cascader__options {
  padding-top: 0;
}
/deep/.van-cascader__options {
  height: 300px;
}
.picker_toolbar {
  display: flex;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  height: 44px;
}
.picker_cancel {
  height: 100%;
  padding: 0 16px;
  font-size: 14px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.picker_confirm {
  height: 100%;
  padding: 0 16px;
  font-size: 14px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #886df3;
}
.picker_title {
  max-width: 50%;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}
/deep/.van-search__content--round {
  height: 40px;
}
/deep/.van-field__body {
  height: 30px !important;
}
/deep/.van-icon-search {
  margin-top: -2px;
}
</style>